import PfmView from "./PfmView";

export default function PropFirmManagerPage() {
  return <PfmView />;
}
